<template>
  <img
    v-if="!isError"
    :src="src"
    :class="imgClass"
    :alt="alt"
    :width="width"
    :height="height"
    loading="lazy"
    @error="errorCatch"
  >
  <BirdSkin
    v-else
    type="default"
    :bird-class="birdClass"
  />
</template>

<script setup>
import { ref } from 'vue'
import BirdSkin from '@/components/svg/birds/BirdSkin.vue'

const isError = ref(false);

defineProps({
  src: {
    type: String,
    default: undefined,
  },

  alt: {
    type: String,
    default: '',
  },

  imgClass: {
    type: String,
    default: 'embed-responsive-item image-cover',
  },
  birdClass: {
    type: String,
    default: 'w-100 h-auto',
  },

  height: {
    type: String,
    default: 'auto',
  },

  width: {
    type: String,
    default: 'auto',
  },
})

const errorCatch = () => {
  isError.value = true
}
</script>
